import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router'
import { Store } from '@ngrx/store'
import { Observable, of } from 'rxjs'
import { map } from 'rxjs/operators'
import { AppState } from '../store/state/app.state'
import { AuthService } from '../services/auth/auth.service'

@Injectable({ providedIn: 'root' })
export class AuthGuard {
  constructor(private authService: AuthService, private appState: Store<AppState>) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return of(this.authService.isUserAuthenticated()).pipe(
      map(isAuthenticated => {
        if (!isAuthenticated) {
          this.authService.redirectToLogin()
          return true
        }
        return true
      })
    )
  }
}
